export const bookingsRoutes = {
  list: "",
  createAsset: "assets/new",
  assetDetail: "assets/:id",
  editAsset: "assets/:id/edit",
  bookAsset: "assets/:aid/book",
  editBooking: "assets/:aid/book/:bid/edit",
} as const;
